import { show, hide } from 'redux-modal'
import { SHARE_VIA_EMAIL_MODAL } from 'constant'

export const showShareViaEmailModal = ({ title, description, requestPayload }) =>
  show(SHARE_VIA_EMAIL_MODAL, { title, description, requestPayload })

export const hideShareViaEmailModal = () =>
  hide(SHARE_VIA_EMAIL_MODAL)
